/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

:host {
  display: flex;
  flex-direction: column;
}

.item-wrapper {
  display: flex;
  background-color: var(--calcite-color-foreground-1);
  inline-size: -moz-fit-content;
  inline-size: fit-content;
  outline: 1px solid var(--calcite-color-border-input);
  outline-offset: -1px;
}

:host([appearance=outline]) > .item-wrapper {
  background-color: transparent;
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

:host([layout=vertical]) > .item-wrapper {
  flex-direction: column;
  align-items: flex-start;
  align-self: flex-start;
}

:host([width=full]) > .item-wrapper {
  inline-size: 100%;
  min-inline-size: -moz-fit-content;
  min-inline-size: fit-content;
}
:host([width=full]) > .item-wrapper ::slotted(calcite-segmented-control-item) {
  flex: 1 1 auto;
}

:host([width=full][layout=vertical]) > .item-wrapper ::slotted(calcite-segmented-control-item) {
  justify-content: flex-start;
}

.validation-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
}

:host([scale=m]) .validation-container,
:host([scale=l]) .validation-container {
  padding-block-start: 0.5rem;
}

:host([scale=s]) .validation-container {
  padding-block-start: 0.25rem;
}

::slotted(input[slot=hidden-form-input]) {
  margin: 0 !important;
  opacity: 0 !important;
  outline: none !important;
  padding: 0 !important;
  position: absolute !important;
  inset: 0 !important;
  transform: none !important;
  -webkit-appearance: none !important;
  z-index: -1 !important;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}